module.exports = __webpack_public_path__ + "static/Features-04189a06b18e21565abf3bb2ca77c781.png";